import React, { useState } from 'react'
import { Button, Collapse,notification } from 'antd'
import { chooseEmailModalFxn, DisplayDate } from '../../../../components/_utils/appUtils'
import { RowTable } from '../../../article/articleView/RowTable'
import RevisedAbstractDrawer from '../abstractPages/RevisedAbstractDrawer'
import { SendAbstractEmailAction } from '../../actions'
import { useDispatch } from 'react-redux'

const { Panel } = Collapse

const RevisedAbstractPage = (props) => {
  let { abstract } = props
  let dispatch = useDispatch()

  // Abstract specific fields
  let {
    revisedAbstractDate,
    sendToAuthorDate,
    revisedAbstractAttachment,
    responseFromAuthorAttachment
  } = abstract

  let [visibleRevisedAbstract, setVisibleRevisedAbstract] = useState(false)
  let headerTitle = `Revised Abstract ${revisedAbstractDate ? `(${DisplayDate(revisedAbstractDate)})` : ''}`

  let events = {
    show: () => setVisibleRevisedAbstract(true),
    hide: () => setVisibleRevisedAbstract(false)
  }

  // Email: Send to Reviewer
  let sendMailToReviewer = () => {
    chooseEmailModalFxn({
      callback: async (email) => {
        let obj = {
          abstractId: abstract._id,
          fromEmail: email,
          emailType: 'revisedAbstractReviewer',
          template: 'revisedAbstractReviewer',
          model: 'Abstract',
          status:'Revised absrtact reviewer',
          type: 'abstract',
          reviewerId: (abstract.selectedReviewer &&
            abstract.selectedReviewer.length > 0 &&
            abstract.selectedReviewer[0].reviewerId)
            ? abstract.selectedReviewer[0].reviewerId
            : null
        }
        let resp = await dispatch(SendAbstractEmailAction({
          email: obj.fromEmail,
          id: abstract._id,
          obj,
          template: obj.template,
          reviewerId: obj.reviewerId
        }))
        if (resp && resp.success) {
          // Trigger a refresh of the abstract data
          dispatch({ type: 'START_LOAD_ABSTRACT' })
        }
      }
    })
  }

  // Email: Not as per format
  const sendMailNotPerFormat = (record) => {
    chooseEmailModalFxn({
      callback: async (email) => {
        let obj = {
          abstractId: record._id,
          fromEmail: email,
          emailType: 'abstractNotAsPerFormat',
          template: 'abstractNotAsPerFormat',
          model: 'Abstract',
          type: 'abstract',
          status: 'Not as per format'
        };

        let resp = await dispatch(SendAbstractEmailAction({
          email,
          id: record._id,
          obj,
          template: obj.template
        }));

        if (resp && resp.success) {
          notification.success({ message: resp.message });
          // Use the callback prop from the parent instead of this.reload()
          if (props.callback) {
            props.callback();
          }
        }
      }
    });
  };
  let getExtraButton = () => (
    <React.Fragment>
      {revisedAbstractDate && (
        <>
          <Button
            type={'primary'}
            size={'small'}
            style={{ backgroundColor: 'black', borderColor: 'black', color: 'white' }}
            onClick={() => sendMailNotPerFormat(abstract)} // Pass 'abstract' here
          >
            Not as per format
          </Button>
          {' '}
          <Button type={'primary'} size={'small'} onClick={(e) => { e.stopPropagation(); sendMailToReviewer(); }}>
            To Reviewer
          </Button>
        </>
      )}
      {' '}
      {sendToAuthorDate && !revisedAbstractDate && (
        <Button type={'primary'} size={'small'} onClick={(e) => { e.stopPropagation(); events.show(); }}>
          Add
        </Button>
      )}
      {revisedAbstractDate && (
        <Button type={'primary'} size={'small'} onClick={(e) => { e.stopPropagation(); events.show(); }}>
          Edit
        </Button>
      )}
    </React.Fragment>
  )

  return (
    <div>
      <Collapse expandIconPosition={'right'} defaultActiveKey={['1']}>
        <Panel header={headerTitle} key='1' extra={getExtraButton()}>
          <div className={'tableBox striped'}>
            <RowTable title={'Date'} value={revisedAbstractDate && DisplayDate(revisedAbstractDate)} />
            <RowTable title={'Revised Abstract Attachment'} value={
              (revisedAbstractAttachment && revisedAbstractAttachment.path) ?
                <a download className='downloadLink' target={'_blank'} href={revisedAbstractAttachment.path}>Download</a> : 'No Attachment'
            } />
            <RowTable title={'Response from Author Attachment'} value={
              (responseFromAuthorAttachment && responseFromAuthorAttachment.path) ?
                <a download className='downloadLink' target={'_blank'} href={responseFromAuthorAttachment.path}>Download</a> : 'No Attachment'
            } />          </div>
        </Panel>
      </Collapse>
      {/*{visibleRevisedAbstract && (*/}
      {/*  <RevisedAbstractDrawer*/}
      {/*    visible={visibleRevisedAbstract}*/}
      {/*    abstractId={abstract._id}*/}
      {/*    abstract={abstract}*/}
      {/*    edit={!!revisedAbstractDate}*/}
      {/*    onClose={() => events.hide()}*/}
      {/*  />*/}
      {/*)}*/}
      {/*{visibleRevisedAbstract && (*/}
      {/*  <RevisedAbstractDrawer*/}
      {/*    visible={visibleRevisedAbstract}*/}
      {/*    abstractId={abstract._id}*/}
      {/*    abstract={abstract}*/}
      {/*    edit={!!revisedAbstractDate}*/}
      {/*    onClose={() => {*/}
      {/*      events.hide();*/}
      {/*    }}*/}
      {/*  />*/}
      {/*)}*/}
      {visibleRevisedAbstract && (
        <RevisedAbstractDrawer
          visible={visibleRevisedAbstract}
          abstractId={abstract._id}
          abstract={abstract}
          edit={!!revisedAbstractDate}
          onClose={() => events.hide()}
          callback={props.callback}
        />
      )}
    </div>
  )
}

export default RevisedAbstractPage
